'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.CONTENT_TYPE_JSON_UTF8 = exports.CONTENT_TYPE_JSON = exports.CONTENT_TYPE_FORM_URLENCODED_UTF8 = exports.CONTENT_TYPE_FORM_URLENCODED = undefined;

var _stringify = require('babel-runtime/core-js/json/stringify');

var _stringify2 = _interopRequireDefault(_stringify);

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _typeof2 = require('babel-runtime/helpers/typeof');

var _typeof3 = _interopRequireDefault(_typeof2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _fetch = require('./fetch');

var _log = require('../log');

var _log2 = _interopRequireDefault(_log);

var _has = require('../helper/has');

var _has2 = _interopRequireDefault(_has);

var _template = require('../helper/template');

var _template2 = _interopRequireDefault(_template);

var _get = require('lodash/get');

var _get2 = _interopRequireDefault(_get);

var _isNil = require('lodash/isNil');

var _isNil2 = _interopRequireDefault(_isNil);

var _isNaN = require('lodash/isNaN');

var _isNaN2 = _interopRequireDefault(_isNaN);

var _trim = require('lodash/trim');

var _trim2 = _interopRequireDefault(_trim);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CONTENT_TYPE_FORM_URLENCODED = exports.CONTENT_TYPE_FORM_URLENCODED = 'application/x-www-form-urlencoded';
var CONTENT_TYPE_FORM_URLENCODED_UTF8 = exports.CONTENT_TYPE_FORM_URLENCODED_UTF8 = CONTENT_TYPE_FORM_URLENCODED + ';charset=UTF-8';

var CONTENT_TYPE_JSON = exports.CONTENT_TYPE_JSON = 'application/json';
var CONTENT_TYPE_JSON_UTF8 = exports.CONTENT_TYPE_JSON_UTF8 = CONTENT_TYPE_JSON + ';charset=UTF-8';

var defaultOptions = {
  debug: false,
  logging: false,
  path: '/',
  protocol: 'https'
};

var Api = function () {
  function Api(options) {
    (0, _classCallCheck3.default)(this, Api);

    var o = (0, _assign2.default)({}, defaultOptions, options);

    if (o.prefix === undefined) o.prefix = o.path;

    this._options = o;

    this._endpoints = {};
  }

  (0, _createClass3.default)(Api, [{
    key: '_getMeta',
    value: function _getMeta(name) {
      return (0, _get2.default)(this._endpoints, name);
    }
  }, {
    key: '_getValidMethod',
    value: function _getValidMethod() {
      var method = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'GET';

      method = (0, _trim2.default)(method).toUpperCase();

      return (0, _has2.default)(['DELETE', 'GET', 'PATCH', 'POST', 'PUT'], method) ? method : 'GET';
    }
  }, {
    key: 'buildFetch',
    value: function buildFetch(method) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'application/json';

      var headers = this.buildHeaders(state);
      var validMethod = this._getValidMethod(method);

      if (contentType !== null && (0, _has2.default)(['PATCH', 'POST', 'PUT'], validMethod)) {
        headers['Content-Type'] = contentType;
      }

      return { headers: headers, method: validMethod };
    }
  }, {
    key: 'buildHeaders',
    value: function buildHeaders() {
      var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

      return {};
    }
  }, {
    key: 'buildQueryParams',
    value: function buildQueryParams(name) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var meta = this._getMeta(name);

      var params = [];

      var value = void 0;

      if (meta) {
        if (Array.isArray(meta.queryParams)) {
          // queryParams as array, e.g. ['limit', 'offset', 'order_by=desc']
          meta.queryParams.forEach(function (param) {
            var _param$split = param.split('='),
                _param$split2 = (0, _slicedToArray3.default)(_param$split, 2),
                key = _param$split2[0],
                defaultValue = _param$split2[1];

            if (typeof param === 'string') {
              value = state[key] !== undefined ? state[key] : defaultValue;
            }

            if ((0, _trim2.default)(value) !== '' && !(0, _isNaN2.default)(value)) params.push(key + '=' + value);
          });
        } else if ((0, _typeof3.default)(meta.queryParams) === 'object') {
          // queryParams as object, e.g. { limit: undefined, offset: undefined, order_by: 'desc' }
          (0, _keys2.default)(meta.queryParams).forEach(function (param) {
            if (meta.queryParams.hasOwnProperty(param)) {
              value = state[param] !== undefined ? state[param] : meta.queryParams[param];

              if ((0, _trim2.default)(value) !== '' && !(0, _isNaN2.default)(value)) params.push(param + '=' + value);
            }
          });
        }
      }

      return params.sort();
    }
  }, {
    key: 'buildPayload',
    value: function buildPayload(name, data) {
      var meta = this._getMeta(name);
      var metaBody = meta && meta.body || {};

      var payload = {};

      var transformValue = this.transformValue;

      function processMetaBody(key) {
        var groupKey = metaBody[key].groupKey;

        if (typeof groupKey !== 'string') return;

        var groupBody = metaBody[key].groupBody;

        if ((typeof groupBody === 'undefined' ? 'undefined' : (0, _typeof3.default)(groupBody)) !== 'object') return;

        for (var subKey in groupBody) {
          if (!groupBody.hasOwnProperty(subKey)) continue;

          if (data[subKey] !== undefined) {
            if ((0, _typeof3.default)(payload[groupKey]) !== 'object') payload[groupKey] = {};

            payload[groupKey][groupBody[subKey]] = transformValue(subKey, data[subKey]);
          }
        }
      }

      for (var key in metaBody) {
        if (!metaBody.hasOwnProperty(key)) continue;

        if ((0, _typeof3.default)(metaBody[key]) === 'object') {
          processMetaBody(key);
        } else if (data[key] !== undefined) {
          payload[metaBody[key]] = transformValue(key, data[key]);
        }
      }

      return payload;
    }
  }, {
    key: 'buildBody',
    value: function buildBody(name) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';

      if (this._getValidMethod(method) === 'GET') return;

      return !(0, _isNil2.default)(state.body) ? state.body : this.buildPayload(name, state);
    }
  }, {
    key: 'buildUri',
    value: function buildUri(name) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var meta = this._getMeta(name);

      var o = this._options;

      // Remove trailing slash from URI prefix
      var prefix = o.prefix && o.prefix[o.prefix.length - 1] === '/' ? o.prefix.substr(0, o.prefix.length - 1) : o.prefix;

      if (!meta) throw new Error('No endpoint metadata found for "' + name + '"');

      var queryType = this.getQueryType(meta, state);

      var route = void 0;

      if (typeof meta === 'string') {
        route = prefix + meta;
      } else if (queryType) {
        route = (0, _template2.default)(meta[queryType], meta.params ? {
          parent: state[meta.params.parent],
          record: state[meta.params.record]
        } : {});

        if (!meta.noPrefix) route = prefix + route;
      }

      // Remove trailing slash from route
      if (route[route.length - 1] === '/') route = route.substr(0, route.length - 1);

      return o.protocol + '://' + o.domain + (o.port ? ':' + o.port : '') + route;
    }
  }, {
    key: 'getQueryType',
    value: function getQueryType(meta) {
      var state = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      var queryType = void 0;

      if ((typeof meta === 'undefined' ? 'undefined' : (0, _typeof3.default)(meta)) !== 'object') return;

      if (meta.params) {
        if (state[meta.params.parent] !== undefined) {
          queryType = 'many';
        } else if (state[meta.params.record] !== undefined) {
          queryType = 'one';
        }
      }

      if (!queryType) queryType = meta.many ? 'many' : 'one';

      return queryType;
    }
  }, {
    key: 'query',
    value: function query(name, state) {
      var method = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'GET';
      var execute = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;

      var meta = this._getMeta(name);

      var contentType = meta && meta.multipart ? null // NOTE: This allows Content-Type to be auto-set w/ correct `boundary`
      : meta.contentType || CONTENT_TYPE_JSON;

      // Query building dependencies should be in all records, so we only need one
      var firstRecord = Array.isArray(state) ? state[0] : state;

      var queryParams = this.buildQueryParams(name, firstRecord);

      var fetchOptions = this.buildFetch(method, firstRecord, contentType);

      var uri = this.buildUri(name, firstRecord);

      var body = this.buildBody(name, state, method);

      if (body) {
        fetchOptions.body = contentType && (0, _has2.default)(contentType, CONTENT_TYPE_JSON, 0) ? (0, _stringify2.default)(body) : body;
      }

      var config = {
        fetchOptions: fetchOptions,
        uri: queryParams.length ? uri + '?' + queryParams.join('&') : uri
      };

      if (this._options.debug) execute = false;

      if (this._options.logging) _log2.default.info('[api.query] ' + name, config);

      if (!execute) return config;

      var response = (0, _fetch.fetch)(config.uri, config.fetchOptions);

      if (typeof this._options.processFetchResponse === 'function') {
        return response.then(this._options.processFetchResponse);
      }

      return response;
    }
  }, {
    key: 'transformValue',
    value: function transformValue(key, value) {
      return value;
    }
  }]);
  return Api;
}();

exports.default = Api;
//# sourceMappingURL=Api.js.map